import { render } from "./HeaderWhite.vue?vue&type=template&id=3b7ec5f4"
import script from "./HeaderWhite.vue?vue&type=script&lang=js"
export * from "./HeaderWhite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__